module.exports = __webpack_public_path__ + "media/images/front/programs/icon-arrow-right-inactive-49d576c714034c1d332028bc8375172e.svg";